import { Dialog } from '@mui/material'
import { useContext, useEffect, useMemo, useState } from 'react'
import { isValidPhoneNumber } from 'react-phone-number-input'
import { useNavigate } from 'react-router'
import { InfoWithHeadingDescriptionAndImage } from 'src/consumer/components/ListingPageComponentsAndHelpers/ListingPageComponents'
import { PublicAppFooter } from 'src/consumer/components/PublicAppFooter'
import PublicAppHeader from 'src/consumer/components/PublicAppHeader'
import { ClubbedAuthModal } from 'src/consumer/components/SignIn/ClubbedAuthComponents'
import { INITAL_CLUBBED_AUTH_MODAL_BASIC_DETAILS_STATE } from 'src/consumer/components/SignIn/ClubbedAuthComponents/utils'
import {
  CustomCheckBox,
  CustomInput,
  CustomSelect,
  selectTypes,
} from 'src/consumer/components/helperComponents'
import { APP_CONSTANTS, MENTOR_ONBOARDING_TYPES } from 'src/consumer/constants'
import { UnsecureSetupContext } from 'src/consumer/context/UnsecureSetupContext'
import { SEOComponent, validateEmail } from 'src/consumer/helpers/utilFunctions'
import { postDataWithoutParams } from 'src/consumer/services/featureServices'
import { getImageLink, isBasicOnboardingDone } from 'src/mentor/helpers/utilityFunctions'
import {
  getIsTeacherOrCreatorData,
  getOnboardingType,
  setJustOnboardedTeacher,
  setLocalStorageOnboardingType,
} from 'src/mentor/layout/utils'
import {
  getMPDataWithoutParams,
  getMPDataWithParams,
  postMPDataWithoutParams,
} from 'src/mentor/services'
import {
  MentorJoinModalContent,
  MentorOnboardingFormComponent,
  MentorPageBecomeMentorButton,
  MentorPageInfo,
  MentorPagePrimaryWidgetBackground,
  MentorPagePrimaryWidgetItemsContainer,
  MentorPageSubtitle,
  MentorPageTitle,
  MentorPageTitleH1,
  MentorPublicPageContent,
  MentorPublicPageLayout,
  StyledDialogActions,
  StyledDialogJoinButton,
  StyledDialogPaper,
  StyledDialogSingleAction,
  StyledDialogTitle,
  StyledDialogVerifiedButton,
  StyledEmailNotVerifiedMessage,
  StyledMentorEmailInputAndMessageContainer,
  StyledMentorJoinVerifyLink,
  StyledMentorJoinVerifyLinkAfter,
} from './MentorPublicPageStyledComponents'
import {
  getMentorJoinEmailInvalidity,
  getMentorJoinPageStrings,
  getMentorJoinPhoneInvalidity,
  isSameMentorJoinMobileValue,
  normalizeMentorJoinMobileValue,
} from './utis'

export default function MentorPublicPage({ blankPage }) {
  const { unSecureSetupData } = useContext(UnsecureSetupContext)
  const [showJoinForm, setShowJoinForm] = useState(blankPage ? true : false)
  const [formState, setFormState] = useState({})
  const [profileData, setProfileData] = useState()
  const navigate = useNavigate()
  const token = localStorage.getItem('token')
  const teacherCreatorData = getIsTeacherOrCreatorData()
  const [showClubbedAuthModal, setShowClubbedAuthModal] = useState(false)
  const [typeOfClubbedAuthModal, setTypeOfClubbedAuthModal] = useState('signup')

  const urlParams = new URLSearchParams(window.location.search)
  const onboardingType = urlParams.get('type')

  const doctorOnboarding = onboardingType === 'doctor'
  const therapistOnboarding = onboardingType === 'therapist'

  function handleChange(event) {
    if (event.target.type === 'checkbox') {
      setFormState((prev) => ({ ...prev, [event.target.id]: event.target.checked }))
    } else {
      setFormState((prev) => ({ ...prev, [event.target.id]: event.target.value }))
    }
  }

  function handleJoinMentor() {
    if (token && isBasicOnboardingDone(profileData)) {
      handleOpenForm()
    } else if (token && !isBasicOnboardingDone(profileData)) {
      handleOpenForm()
      // navigate('/onboarding', {
      //   state: {
      //     redirectAfterLogin: true,
      //     redirectAfterRegistration: true,
      //     redirectAfterOnboarding: false,
      //     redirectTo: '/mentors/apply',
      //     redirectData: {
      //       mustHaveDoneBasicOnboarding: true,
      //       prospectiveMentor: true,
      //     },
      //   },
      // })
    } else {
      setShowClubbedAuthModal(true)
      // navigate('/onboarding', {
      //   state: {
      //     redirectAfterLogin: true,
      //     redirectAfterRegistration: true,
      //     redirectAfterOnboarding: false,
      //     redirectTo: '/mentors/apply',
      //     redirectData: {
      //       mustHaveDoneBasicOnboarding: true,
      //       prospectiveMentor: true,
      //     },
      //   },
      // })
    }
  }

  function handleOpenForm() {
    if (teacherCreatorData?.isTeacher || teacherCreatorData?.isCreator) {
      navigate('/mentor-home')
    } else {
      setShowJoinForm(true)
    }
  }

  function handleClose() {
    if (!blankPage) {
      setShowJoinForm(false)
    }
  }

  async function getProfileData(setEmailNotVerifiedShow) {
    const resp = await getMPDataWithoutParams('/api/secure/user/profile')
    if (resp?.status === 200) {
      const profileData = resp.data
      setProfileData(profileData)
      console.log(unSecureSetupData)
      const locationCountryCode = localStorage.getItem('countryCode') || 'in'
      const foundCountry = unSecureSetupData?.metaCountries.find(
        (country) => country.id === locationCountryCode.toLowerCase(),
      )
      setEmailNotVerifiedShow && !resp?.data?.emailVerified && setEmailNotVerifiedShow(true)
      setEmailNotVerifiedShow && resp?.data?.emailVerified && setEmailNotVerifiedShow(false)
      setFormState((prev) => {
        console.log(prev)
        console.log(resp?.data?.email)
        return {
          ...prev,
          email: prev?.email || resp?.data?.email || '',
          mobile: prev?.mobile || resp?.data?.mobile || '',
          firstName: prev?.firstName || resp?.data?.firstName || '',
          location: {
            country:
              prev?.location?.country ||
              resp?.data?.location?.country ||
              foundCountry?.title ||
              foundCountry?.name ||
              '',
            countryCode:
              prev?.location?.countryCode ||
              resp?.data?.location?.countryCode ||
              foundCountry?.id ||
              '',
          },
        }
      })
    }
  }

  async function Setup() {
    await Promise.all([getProfileData()])

    const openModal = sessionStorage.getItem('openMentorJoinModal')
    if (openModal) {
      handleOpenForm()
    }
  }

  async function handleSubmit(event) {
    const form = event.currentTarget
    if (form.checkValidity() === false) {
      event.preventDefault()
      event.stopPropagation()
    } else {
      event.preventDefault()
      const { terms: _terms, ...toSubmit } = formState
      const response = await postDataWithoutParams('/api/secure/creator/new', toSubmit)
      if (response.status === 200) {
        const role = localStorage.getItem('authorities')
        const role_array = JSON.parse(role)
        localStorage.setItem('authorities', JSON.stringify([...role_array, 'ROLE_CREATOR']))
        // this above line is needed because we are not updating local storage based on profile yet in mentor context, and it won't open without this in local storage
        setJustOnboardedTeacher(true)
        navigate('/mentor-home')
        window.location.reload()
      }
    }
  }

  useEffect(() => {
    const onbType = getOnboardingType()

    console.log('onbType in setting', onbType)

    if (onbType) {
      console.log('not setting onboarding type')
      return
    }

    if (doctorOnboarding) {
      console.log("setting onboarding type to 'doctor")
      setLocalStorageOnboardingType('doctor')
    }
    if (therapistOnboarding) {
      console.log('setting onboarding type to therapist')
      setLocalStorageOnboardingType('therapist')
    }
  }, [onboardingType])

  useEffect(() => {
    const onbType = getOnboardingType()
    console.log({ onbType })
    if (onbType === 'doctor') {
      if (onboardingType !== 'doctor') {
        navigate('/mentors/join?type=doctor')
      }
    }
    if (onbType === 'therapist') {
      if (onboardingType !== 'therapist') {
        navigate('/mentors/join?type=therapist')
      }
    }
  }, [])

  useEffect(() => {
    Setup()
  }, [])

  useEffect(() => {
    if (blankPage && (teacherCreatorData?.isTeacher || teacherCreatorData?.isCreator)) {
      navigate('/mentor-home')
    }
  }, [])

  // public page and redirection:
  function goToLogin() {
    setTypeOfClubbedAuthModal('login')
    setShowClubbedAuthModal(true)
    // navigate('/login', {
    //   state: {
    //     redirectAfterLogin: true,
    //     redirectAfterRegistration: true,
    //     redirectAfterOnboarding: false,
    //     redirectTo: '/mentors/apply',
    //     redirectData: {
    //       mustHaveDoneBasicOnboarding: true,
    //       prospectiveMentor: true,
    //     },
    //   },
    // })
  }
  function goToRegister() {
    setTypeOfClubbedAuthModal('signup')
    setShowClubbedAuthModal(true)
    // navigate('/onboarding', {
    //   state: {
    //     redirectAfterLogin: true,
    //     redirectAfterRegistration: true,
    //     redirectAfterOnboarding: false,
    //     redirectTo: '/mentors/apply',
    //     redirectData: {
    //       mustHaveDoneBasicOnboarding: true,
    //       prospectiveMentor: true,
    //     },
    //   },
    // })
  }

  const pageStrings = getMentorJoinPageStrings({ onboardingType })

  return (
    <>
      <PublicAppHeader loginFunction={goToLogin} registerFunction={goToRegister} />
      <SEOComponent
        title={pageStrings.seo.title}
        description={pageStrings.seo.description}
        image={APP_CONSTANTS.APP_LOGO_LINK}
        keywordsArr={['mentor', 'online', 'job']}
      />
      <ClubbedAuthModal
        open={showClubbedAuthModal}
        onClose={() => {
          setShowClubbedAuthModal(false)
        }}
        loginVariant={typeOfClubbedAuthModal === 'login'}
        nameFieldHeading={'Your Name'}
        initialOnboardingDetails={{
          ...INITAL_CLUBBED_AUTH_MODAL_BASIC_DETAILS_STATE,
          name: onboardingType === MENTOR_ONBOARDING_TYPES.DOCTOR ? 'Dr. ' : '',
        }}
        beforeReloadFunction={() => {
          sessionStorage.setItem('openMentorJoinModal', 'true')
        }}
      />

      {blankPage ? (
        <></>
      ) : (
        <MentorPublicPageLayout>
          <MentorPagePrimaryWidgetItemsContainer>
            <MentorPublicPageContent>
              <MentorPageSubtitle>{pageStrings.subTitle}</MentorPageSubtitle>
              <MentorPageTitle>{pageStrings?.title}</MentorPageTitle>
              <MentorPageTitleH1>{pageStrings?.titleH1}</MentorPageTitleH1>
              <MentorPageInfo>{pageStrings?.pageInfo}</MentorPageInfo>
              <MentorPageBecomeMentorButton onClick={handleJoinMentor}>
                {teacherCreatorData?.isTeacher || teacherCreatorData?.isCreator
                  ? `Proceed ${pageStrings?.joinText}`
                  : `Join ${pageStrings?.joinText}`}
              </MentorPageBecomeMentorButton>
            </MentorPublicPageContent>
            <MentorPagePrimaryWidgetBackground
              src={getImageLink(APP_CONSTANTS.MENTOR_HOME_PUBLIC_PAGE_IMAGE_ID)}
              alt="background"
            />
          </MentorPagePrimaryWidgetItemsContainer>
          <InfoWithHeadingDescriptionAndImage
            headline={pageStrings?.info?.headline}
            description={pageStrings?.info?.description}
            image={getImageLink(APP_CONSTANTS.MENTOR_HOME_PUBLIC_PAGE_THERAPY_IMAGE)}
          />
          <InfoWithHeadingDescriptionAndImage
            pictureOnLeftVariant={true}
            headline={pageStrings?.info2?.headline}
            description={pageStrings?.info2?.description}
            image={getImageLink(APP_CONSTANTS.MENTOR_HOME_PUBLIC_PAGE_FLEXIBLE_SCHEDULE_IMAGE)}
          />
        </MentorPublicPageLayout>
      )}

      <MentorPublicPageBecomeMentorPopup
        open={showJoinForm}
        onClose={handleClose}
        formState={formState}
        profileData={profileData}
        handleChange={handleChange}
        setFormState={setFormState}
        onSubmit={handleSubmit}
        getProfileData={getProfileData}
        pageStrings={pageStrings}
      />
      <PublicAppFooter />
    </>
  )
}

export function MentorPublicPageBecomeMentorPopup({
  onSubmit,
  handleChange,
  profileData,
  formState,
  setFormState,
  getProfileData,
  pageStrings,
  ...rest
}) {
  const { unSecureSetupData } = useContext(UnsecureSetupContext)
  const [clicked, setClicked] = useState(false)
  const [showEmailNotVerified, setShowEmailNotVerified] = useState(false)
  const [verifyingEmail, setVerifyingEmail] = useState(false)
  const [mobileOtp, setMobileOtp] = useState('')
  const [mobileOtpRequested, setMobileOtpRequested] = useState(false)
  const [sendingMobileOtp, setSendingMobileOtp] = useState(false)
  const [verifyingMobileOtp, setVerifyingMobileOtp] = useState(false)
  const [mobileVerificationMessage, setMobileVerificationMessage] = useState('')
  const [mobileVerificationError, setMobileVerificationError] = useState('')
  const emailValid = validateEmail(formState?.email)
  const normalizedMobile = normalizeMentorJoinMobileValue(formState?.mobile)
  const phoneValid = !!normalizedMobile && isValidPhoneNumber(normalizedMobile)
  const verifiedMobileMatchesInput =
    !!profileData?.mobileVerified &&
    isSameMentorJoinMobileValue(profileData?.mobile, normalizedMobile || formState?.mobile)
  const storedMobileMatchesInput = isSameMentorJoinMobileValue(
    profileData?.mobile,
    normalizedMobile || formState?.mobile,
  )
  const storedEmailMatchesInput =
    !formState?.email ||
    formState?.email?.trim()?.toLowerCase() === profileData?.email?.trim()?.toLowerCase()
  const hasVerifiedContact = !!profileData?.emailVerified || !!profileData?.mobileVerified
  const disableJoinMentorButton = useMemo(() => {
    if (!formState?.terms) {
      return true
    }

    if (!hasVerifiedContact) {
      return true
    }

    if (!!formState?.email && !emailValid) {
      return true
    }

    if (!!formState?.mobile && !verifiedMobileMatchesInput && !phoneValid) {
      return true
    }

    if (!!formState?.email && !profileData?.emailVerified) {
      if (!profileData?.mobileVerified || !storedEmailMatchesInput) {
        return true
      }
    }

    if (!!formState?.mobile && !verifiedMobileMatchesInput) {
      if (!profileData?.emailVerified || !storedMobileMatchesInput) {
        return true
      }
    }

    return verifyingEmail || sendingMobileOtp || verifyingMobileOtp
  }, [
    emailValid,
    formState?.email,
    formState?.mobile,
    formState?.terms,
    hasVerifiedContact,
    phoneValid,
    profileData?.emailVerified,
    profileData?.mobileVerified,
    sendingMobileOtp,
    storedEmailMatchesInput,
    storedMobileMatchesInput,
    verifiedMobileMatchesInput,
    verifyingEmail,
    verifyingMobileOtp,
  ])

  async function verifyEmail() {
    setVerifyingEmail(true)
    await getProfileData(setShowEmailNotVerified)
    setVerifyingEmail(false)
  }

  function changeCountry(selectValue) {
    setFormState((prev) => ({
      ...prev,
      location: { ...prev?.location, countryCode: selectValue?.id, country: selectValue?.name },
    }))
  }

  async function removeOpenModal() {
    sessionStorage.removeItem('openMentorJoinModal')
  }

  async function handleSendMobileOtp() {
    if (!phoneValid || !normalizedMobile) {
      setMobileVerificationError('Please enter a valid mobile number with country code.')
      return
    }

    setSendingMobileOtp(true)
    setMobileVerificationError('')
    setMobileVerificationMessage('')

    const response = await getMPDataWithParams('/api/secure/user/mobile/verification/otp/send', {
      mobile: normalizedMobile,
    })

    if (response?.status === 200) {
      setMobileOtpRequested(true)
      setMobileOtp('')
      setMobileVerificationMessage('Verification code sent. Enter the 6-digit code to continue.')
    } else {
      setMobileVerificationError(
        response?.response?.data?.message || 'Unable to send a verification code right now.',
      )
    }

    setSendingMobileOtp(false)
  }

  async function handleVerifyMobileOtp() {
    if (mobileOtp?.trim()?.length !== 6) {
      setMobileVerificationError('Enter the 6-digit verification code.')
      return
    }

    if (!normalizedMobile) {
      setMobileVerificationError('Please enter a valid mobile number first.')
      return
    }

    setVerifyingMobileOtp(true)
    setMobileVerificationError('')
    setMobileVerificationMessage('')

    const otpVerificationResponse = await getMPDataWithParams(
      '/api/secure/user/mobile/verification/otp/verify',
      {
        mobile: normalizedMobile,
        otp: mobileOtp?.trim(),
      },
    )

    const otpToken = otpVerificationResponse?.data?.data?.otpToken

    if (otpVerificationResponse?.status !== 200 || !otpToken) {
      setMobileVerificationError(
        otpVerificationResponse?.response?.data?.message || 'The verification code is invalid.',
      )
      setVerifyingMobileOtp(false)
      return
    }

    const updateResponse = await postMPDataWithoutParams(
      `/api/secure/user/update?languageCode&otpToken=${encodeURIComponent(otpToken)}`,
      {
        ...profileData,
        mobile: normalizedMobile,
      },
    )

    if (updateResponse?.status === 200) {
      setFormState((prev) => ({ ...prev, mobile: normalizedMobile }))
      await getProfileData()
      setMobileOtp('')
      setMobileOtpRequested(false)
      setMobileVerificationMessage('Mobile number verified successfully.')
    } else {
      setMobileVerificationError(
        updateResponse?.response?.data?.message || 'Unable to save your verified mobile number.',
      )
    }

    setVerifyingMobileOtp(false)
  }

  useEffect(() => {
    if (profileData?.emailVerified) {
      setClicked(false)
    }
  }, [profileData])

  useEffect(() => {
    if (verifiedMobileMatchesInput) {
      setMobileOtp('')
      setMobileOtpRequested(false)
      setMobileVerificationError('')
    }
  }, [verifiedMobileMatchesInput])

  useEffect(() => {
    setMobileOtp('')
    setMobileOtpRequested(false)
    setMobileVerificationError('')
    if (!verifiedMobileMatchesInput) {
      setMobileVerificationMessage('')
    }
  }, [normalizedMobile, verifiedMobileMatchesInput])

  useEffect(() => {
    if (rest?.open) {
      removeOpenModal()
    }
  }, [rest?.open])

  return (
    <Dialog PaperComponent={StyledDialogPaper} {...rest}>
      <StyledDialogTitle>{pageStrings?.joinModal?.modalTitle}</StyledDialogTitle>
      <MentorJoinModalContent>
        <MentorOnboardingFormComponent id="join-mentor-form" onSubmit={onSubmit}>
          <CustomInput
            id="firstName"
            type="text"
            label="Name"
            value={formState?.firstName}
            onChange={handleChange}
            required
          />
          <div className="d-flex justify-content-stretch align-items-center">
            <CustomInput
              id="email"
              type="email"
              label="Email"
              invalid={getMentorJoinEmailInvalidity(profileData, emailValid, formState?.email)}
              invalidMessage={formState?.email && 'Your email address is in the wrong format.'}
              valid={profileData?.emailVerified && emailValid}
              disabled={profileData?.emailVerified && !!emailValid}
              value={formState?.email}
              onChange={handleChange}
              inputAndMessageContainer={StyledMentorEmailInputAndMessageContainer}
              required={!profileData?.mobileVerified}
            />
          </div>
          {!profileData?.emailVerified && (
            <InvalidMessage
              profileData={profileData}
              formState={formState}
              clicked={clicked}
              getProfileData={getProfileData}
              setClicked={setClicked}
              emailValid={emailValid}
              setShowEmailNotVerified={setShowEmailNotVerified}
            />
          )}
          <CustomInput
            id="mobile"
            type="tel"
            label="Mobile Number"
            placeholder="+91 98765 43210"
            invalid={getMentorJoinPhoneInvalidity(profileData, phoneValid, formState?.mobile)}
            invalidMessage={
              formState?.mobile && 'Please enter a valid mobile number with country code.'
            }
            valid={verifiedMobileMatchesInput}
            disabled={verifiedMobileMatchesInput}
            value={formState?.mobile}
            onChange={handleChange}
            required={!profileData?.emailVerified}
          />
          {!verifiedMobileMatchesInput && phoneValid && (
            <div className="d-flex flex-column justify-content-start align-items-stretch gap-2">
              {mobileOtpRequested ? (
                <>
                  <CustomInput
                    id="mentor-mobile-otp"
                    type="text"
                    label="Verification Code"
                    placeholder="Enter 6-digit code"
                    value={mobileOtp}
                    onChange={(event) => setMobileOtp(event.target.value.replace(/\D/g, '').slice(0, 6))}
                    required={!profileData?.emailVerified}
                  />
                  <div className="d-flex flex-column justify-content-start align-items-stretch gap-2">
                    <StyledDialogVerifiedButton
                      disabled={verifyingMobileOtp || mobileOtp?.length !== 6}
                      onClick={handleVerifyMobileOtp}
                    >
                      {verifyingMobileOtp ? 'Verifying...' : 'Verify mobile number'}
                    </StyledDialogVerifiedButton>
                    <StyledMentorJoinVerifyLink onClick={sendingMobileOtp ? () => {} : handleSendMobileOtp}>
                      Resend verification code
                    </StyledMentorJoinVerifyLink>
                  </div>
                </>
              ) : (
                <StyledMentorJoinVerifyLink onClick={sendingMobileOtp ? () => {} : handleSendMobileOtp}>
                  {sendingMobileOtp
                    ? 'Sending verification code...'
                    : 'Verify this mobile number with a code'}
                </StyledMentorJoinVerifyLink>
              )}
              {!!mobileVerificationMessage && <div>{mobileVerificationMessage}</div>}
              {!!mobileVerificationError && (
                <StyledEmailNotVerifiedMessage>{mobileVerificationError}</StyledEmailNotVerifiedMessage>
              )}
            </div>
          )}
          <CustomSelect
            id="countries"
            label="Location"
            options={unSecureSetupData?.metaCountries}
            getOptionValue={(option) => option?.id}
            getOptionLabel={(option) => option?.name}
            placeholder="Enter your country...."
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999, fontFamily: 'Outfit' }) }}
            value={formState?.location?.countryCode}
            selectType={selectTypes?.string}
            onChange={changeCountry}
            required
          />
          <CustomCheckBox
            id="terms"
            label={
              <span>
                By checking this box, I agree to AUMHUM&apos;s{' '}
                <StyledMentorJoinVerifyLink
                  underline="always"
                  href="https://aumhum.com/terms"
                  target="_blank"
                >
                  Terms of Service
                </StyledMentorJoinVerifyLink>{' '}
                and{' '}
                <StyledMentorJoinVerifyLink
                  underline="always"
                  href="https://aumhum.com/privacy-policy"
                  target="_blank"
                >
                  Privacy Policy
                </StyledMentorJoinVerifyLink>
                .
              </span>
            }
            checked={formState?.terms}
            onChange={handleChange}
            required
            sx={{
              '&.Mui-checked': {
                color: '#6977df',
              },
            }}
          />
        </MentorOnboardingFormComponent>
      </MentorJoinModalContent>
      <StyledDialogActions>
        {clicked && !profileData?.emailVerified && !profileData?.mobileVerified && (
          <StyledDialogSingleAction>
            <StyledDialogVerifiedButton
              disabled={!formState?.terms || verifyingEmail}
              onClick={verifyEmail}
            >
              I have verified my email.
            </StyledDialogVerifiedButton>
            {showEmailNotVerified &&
              (verifyingEmail ? (
                <StyledEmailNotVerifiedMessage verifyEmail={verifyingEmail}>
                  Verifying...
                </StyledEmailNotVerifiedMessage>
              ) : (
                <StyledEmailNotVerifiedMessage>
                  You need to verify your email before proceeding!
                </StyledEmailNotVerifiedMessage>
              ))}
          </StyledDialogSingleAction>
        )}
        {(!clicked || profileData?.mobileVerified) && (
          <StyledDialogJoinButton
            form="join-mentor-form"
            disabled={disableJoinMentorButton}
            type="submit"
          >
            {pageStrings?.joinModal?.joinButton}
          </StyledDialogJoinButton>
        )}
      </StyledDialogActions>
    </Dialog>
  )
}

function InvalidMessage({
  profileData,
  formState,
  emailValid,
  getProfileData,
  clicked,
  setClicked,
  setShowEmailNotVerified,
}) {
  const [sending, setSending] = useState(false)
  const [savingText, setSavingText] = useState('Sending...')
  async function handleClickVerify() {
    setShowEmailNotVerified(false)
    setSending(true)
    if (emailValid) {
      if (!profileData?.email) {
        setSavingText('Updating email...')
        const response = await postMPDataWithoutParams('/api/secure/user/update?languageCode', {
          ...profileData,
          email: formState?.email,
        })
        if (response.status === 200) {
          await getProfileData()
          setSavingText('Sending email...')
        }
      }
      // profileData?.email
      // fire validation api email
      const response = await getMPDataWithoutParams(
        `/api/user/${profileData?.userId}/email/verify/resend`,
      )
      if (response.status) {
        setClicked(true)
      }
    }
    setSending(false)
  }
  return (
    <>
      {sending ? (
        <div>{savingText}</div>
      ) : (
        <>
          {clicked ? (
            <StyledMentorJoinVerifyLinkAfter>
              Verification email sent, please check your inbox. To resend,{' '}
              <StyledMentorJoinVerifyLink onClick={handleClickVerify}>
                click here
              </StyledMentorJoinVerifyLink>
            </StyledMentorJoinVerifyLinkAfter>
          ) : (
            <>
              {emailValid && (
                <StyledMentorJoinVerifyLink onClick={clicked ? () => {} : handleClickVerify}>
                  Click here to verify your email and continue.
                </StyledMentorJoinVerifyLink>
              )}
            </>
          )}
        </>
      )}
    </>
  )
}

export async function loadCities(search, loadedOptions, { page, size, countryCode }) {
  const response = await getMPDataWithParams(`/api/secure/location/city/search`, {
    search,
    page,
    pageSize: size || 50,
    countryCode,
  })
  var hasMore = true
  var optionsArray = []
  if (response?.status === 200) {
    optionsArray = response?.data?.content
  }
  if (response?.status !== 200 || !optionsArray?.length) {
    hasMore = false
  }
  return {
    options: optionsArray,
    hasMore,
    additional: {
      page: page + 1,
    },
  }
}
